export default "__VITE_ASSET__DSAmGZCu__"